// SR-CUSTOM: Shortlist (favourites) for Design Your Own designs (David, 19 Oct 2026).
// The heart in the header (snippets/sr-shortlist-button.liquid) opens drawer-shortlist (snippets/sr-shortlist-drawer.liquid),
// an ordinary theme drawer. The list lives in this browser (localStorage "sr-shortlist") as
// [{ m, z, b, d, dn, n, t }] = material id, size id (knob/128/160/192/224), button finish slug, door id and door words from
// the Door Visualiser ('' if none), note, time saved. Titles, prices, photos and variant ids come fresh from
// /products/<material>-ensemble-handle.js when the drawer opens.
// Sharing makes a link to /pages/design-your-own?shortlist=<base64url JSON> holding the designs and notes. Opening that link
// shows the list in the drawer with "Save to my shortlist". "Email shortlist" opens a new email with the subject
// "My Sloan Roberts Composition", the designs and notes, and the link (David, 19 Oct). The design page's heart uses window.SRShortlist;
// the heart beside Add to cart on the Ensemble product pages ([data-sr-heart]) is run from here (pdpDesign / pdpState).
// Tracking: dyo_shortlist_* events on the same channels as the builder; share/email links carry UTM tags (shareLink) and
// cart adds from the drawer are listed in the cart attribute "_shortlist" (markCart), both readable in Shopify (19 Oct).
(function () {
  if (window.SRShortlist) return;
  var KEY = 'sr-shortlist', MAX = 30, NOTE_MAX = 200, SUBJECT = 'My Sloan Roberts Composition';
  var body = document.querySelector('[data-shortlist-body]'), foot = document.querySelector('[data-shortlist-foot]');
  var title = document.querySelector('[data-shortlist-title]');

  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function slug(t) { return String(t).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }
  function sizeId(label) { return /knob/i.test(label) ? 'knob' : ((String(label).match(/\d+/) || [''])[0]); }
  function key(it) { return it.m + '|' + it.z + '|' + it.b; }
  function article(w) { return /^[aeiou]/i.test(String(w)) ? 'an' : 'a'; }   // "an Ebonised timber door"
  function clean(it) {
    if (!it || typeof it !== 'object') return null;
    var o = { m: slug(it.m || ''), z: slug(it.z || ''), b: slug(it.b || ''), d: slug(it.d || ''), dn: String(it.dn || '').slice(0, 60), n: String(it.n || '').slice(0, NOTE_MAX), t: +it.t || Date.now() };
    return o.m && o.z && o.b ? o : null;
  }
  function load() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.map(clean).filter(Boolean) : []; } catch (e) { return []; }
  }
  function emit(list) {
    var n = list.length;
    document.querySelectorAll('[data-shortlist-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    document.querySelectorAll('[data-open="drawer-shortlist"]').forEach(function (b) { b.setAttribute('aria-label', n ? 'Shortlist, ' + n + (n === 1 ? ' design' : ' designs') : 'Shortlist'); });
    document.dispatchEvent(new CustomEvent('sr-shortlist:change', { detail: { count: n } }));
  }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} emit(list); }

  function track(name, extra) {
    var p = extra || {}, meta = { shortlist_open: 'DYOShortlistOpen', shortlist_share: 'DYOShortlistShare', shortlist_shared_open: 'DYOShortlistSharedOpen', shortlist_saved_shared: 'DYOShortlistSavedShared', shortlist_add_to_cart: 'DYOShortlistAddToCart', shortlist_email: 'DYOShortlistEmail', shortlist_add: 'DYOShortlistAdd', shortlist_remove: 'DYOShortlistRemove' };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('dyo_' + name, p); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'dyo_' + name, p); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', meta[name] || 'DYO' + name, p); } catch (e) {}
  }

  // Designs added to the cart from the shortlist are listed in the cart attribute "_shortlist" (e.g. "oak_160_brass, walnut_knob_brass"),
  // which carries onto the order, so orders that came through the shortlist can be counted. An attribute, not a line property,
  // so the cart lines still merge with the same item added elsewhere and nothing new shows in the cart or emails.
  function markCart(it) {
    var k = it.m + '_' + it.z + '_' + it.b, json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var have = String((c.attributes || {})._shortlist || '').split(/,\s*/).filter(Boolean);
      if (have.indexOf(k) >= 0) return;
      have.push(k);
      return fetch(((window.routes && routes.cart_update_url) || '/cart/update') + '.js', { method: 'POST', headers: json, body: JSON.stringify({ attributes: { _shortlist: have.join(', ') } }) });
    }).catch(function () {});
  }

  // Share links: base64url of [[m, z, b, d, dn, n], ...] (UTF-8 safe)
  function encode(list) {
    var s = JSON.stringify(list.map(function (it) { return [it.m, it.z, it.b, it.d, it.dn, it.n]; }));
    return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decode(t) {
    t = String(t).replace(/-/g, '+').replace(/_/g, '/');
    while (t.length % 4) t += '=';
    var a = JSON.parse(decodeURIComponent(escape(atob(t))));
    return (Array.isArray(a) ? a : []).slice(0, MAX).map(function (r) { return Array.isArray(r) ? clean({ m: r[0], z: r[1], b: r[2], d: r[3], dn: r[4], n: r[5] }) : null; }).filter(Boolean);
  }
  function previewParam() {
    var pv = new URLSearchParams(location.search).get('preview_theme_id');
    return pv ? '&preview_theme_id=' + encodeURIComponent(pv) : '';
  }
  // Tagged so visits from shared shortlists show in Shopify's reports (source "shortlist", not "share": the builder reads
  // utm_source=share as one shared design): FROM sessions SHOW sessions WHERE utm_campaign = 'shared-shortlist' GROUP BY utm_medium
  function shareLink(list, medium) {
    return location.origin + '/pages/design-your-own?shortlist=' + encode(list) + '&utm_source=shortlist&utm_medium=' + medium +
      '&utm_campaign=shared-shortlist&utm_content=' + list.length + (list.length === 1 ? '-design' : '-designs') + previewParam();
  }
  // The email lists each design in words (no product lookups needed), its note, and the link
  function words(s) { return String(s).split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' '); }
  function emailHref(list) {
    var lines = list.map(function (it, i) {
      var l = (i + 1) + '. ' + words(it.m) + ' Ensemble ' + (it.z === 'knob' ? 'Knob, 40mm' : 'Handle, ' + it.z + 'mm centres') + ', ' + words(it.b) + ' button';
      if (it.dn) l += ' (seen on ' + article(it.dn) + ' ' + it.dn + ' door)';
      if (it.n) l += '\r\n   Note: ' + it.n;
      return l;
    });
    var body = 'Here is my Sloan Roberts composition:\r\n\r\n' + lines.join('\r\n') + '\r\n\r\nSee it here:\r\n' + shareLink(list, 'email') + '\r\n';
    return 'mailto:?subject=' + encodeURIComponent(SUBJECT) + '&body=' + encodeURIComponent(body);
  }
  function designUrl(it) { return '/pages/design-your-own?material=' + encodeURIComponent(it.m) + '&size=' + encodeURIComponent(it.z) + '&button=' + encodeURIComponent(it.b) + previewParam(); }

  // Product data, fetched once per material
  var products = {};
  function product(m) {
    var h = m + '-ensemble-handle';
    if (!products[h]) products[h] = fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .catch(function (e) { delete products[h]; throw e; });
    return products[h];
  }
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    try { return new Intl.NumberFormat(cur === 'USD' ? 'en-US' : 'en-AU', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function resolve(it) {
    return product(it.m).then(function (p) {
      var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
      var si = Math.max(0, names.indexOf('Size')), fi = names.indexOf('Detail Finish'); if (fi < 0) fi = 1;
      var v = (p.variants || []).filter(function (x) { return sizeId(x.options[si]) === it.z && slug(x.options[fi]) === it.b; })[0];
      var img = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
      if (img) img = (img.indexOf('//') === 0 ? 'https:' + img : img) + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=200';
      return {
        name: p.title.replace(/\s*Ensemble Handle$/i, '') + ' Ensemble ' + (it.z === 'knob' ? 'Knob' : 'Handle'),
        spec: (it.z === 'knob' ? '40mm knob' : it.z + 'mm centres') + (v ? ' · ' + v.options[fi] + ' button' : ''),
        price: v ? money(v.price) : '', id: v ? v.id : null, available: !!(v && v.available), img: img
      };
    });
  }

  // ---- drawer
  var view = 'mine', shared = null, noteTimer;
  function itemHtml(it, i, mode) {
    var url = designUrl(it);
    return '<article class="sr-sl-item" data-sl-i="' + i + '">' +
      '<a class="sr-sl-img" href="' + esc(url) + '" data-sl-edit><img alt="" width="72" height="72" data-sl-img></a>' +
      '<div class="sr-sl-info"><p class="sr-sl-name" data-sl-name> </p><p class="sr-sl-spec" data-sl-spec></p>' +
      (it.dn ? '<p class="sr-sl-door">Seen on ' + article(it.dn) + ' ' + esc(it.dn) + ' door</p>' : '') + '<p class="sr-sl-price" data-sl-price></p></div>' +
      (mode === 'mine' ? '<button type="button" class="sr-sl-remove" data-sl-remove aria-label="Remove from shortlist">×</button>' : '<span></span>') +
      (mode === 'mine'
        ? '<label class="sr-sl-note"><span class="visually-hidden">Note</span><textarea data-sl-note rows="2" maxlength="' + NOTE_MAX + '" placeholder="Add a note, e.g. kitchen drawers × 8">' + esc(it.n) + '</textarea></label>'
        : (it.n ? '<p class="sr-sl-quote">“' + esc(it.n) + '”</p>' : '')) +
      '<div class="sr-sl-actions"><button type="button" class="btn btn--primary sr-sl-add" data-sl-add disabled>Add to cart</button>' +
      '<a class="sr-sl-link" href="' + esc(url) + '" data-sl-edit>' + (mode === 'mine' ? 'Edit design' : 'Open design') + '</a></div>' +
      '</article>';
  }
  function render() {
    if (!body) return;
    var mode = view === 'shared' && shared ? 'shared' : 'mine', list = mode === 'shared' ? shared : load();
    if (title) title.textContent = mode === 'shared' ? 'Shared shortlist' : 'Shortlist';
    if (!list.length) {
      body.innerHTML = '<div class="sr-sl-empty"><p>Your shortlist is empty.</p><p>Tap the heart beside Add to cart on any Ensemble handle or on Design Your Own to save a design here, with a note if you like.</p>' +
        '<a class="btn btn--primary" href="/pages/design-your-own' + (previewParam() ? '?' + previewParam().slice(1) : '') + '">Design your own</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    // Share / Email (or Save, for a shared list) sit in a bar at the top, not in the drawer footer: on iPhone the
    // footer could open behind Safari's bottom toolbar (David, 19 Oct)
    var bar = mode === 'shared'
      ? '<div class="sr-sl-bar"><button type="button" class="btn btn--primary sr-sl-wide" data-sl-save>Save to my shortlist</button>' + (load().length ? '<button type="button" class="sr-sl-ghost sr-sl-wide" data-sl-mine>Back to my shortlist</button>' : '') + '<p class="sr-sl-msg" data-sl-msg aria-live="polite"></p></div>'
      : '<div class="sr-sl-bar"><button type="button" class="sr-sl-ghost" data-sl-share>Share</button><a class="sr-sl-ghost" href="#" data-sl-email>Email</a><p class="sr-sl-hint">Both include your notes.</p><p class="sr-sl-msg" data-sl-msg aria-live="polite"></p></div>';
    body.innerHTML = (mode === 'shared' ? '<p class="sr-sl-intro">Someone shared these designs with you.</p>' : '') + bar +
      '<div class="sr-sl-list">' + list.map(function (it, i) { return itemHtml(it, i, mode); }).join('') + '</div>';
    if (foot) foot.hidden = true;
    list.forEach(function (it, i) {
      var row = body.querySelector('.sr-sl-item[data-sl-i="' + i + '"]');
      resolve(it).then(function (r) {
        row.querySelector('[data-sl-name]').textContent = r.name;
        row.querySelector('[data-sl-spec]').textContent = r.spec;
        row.querySelector('[data-sl-price]').textContent = r.price ? r.price + ' inc GST' : '';
        if (r.img) row.querySelector('[data-sl-img]').src = r.img;
        var add = row.querySelector('[data-sl-add]');
        add.disabled = !r.id || !r.available;
        if (!r.available) add.textContent = 'Sold out';
        add.setAttribute('data-sl-variant', r.id || '');
      }).catch(function () { row.querySelector('[data-sl-name]').textContent = 'This design is no longer available'; });
    });
  }
  function msg(t) { var el = body && body.querySelector('[data-sl-msg]'); if (el) el.textContent = t; }
  function openDrawer() {
    var b = document.querySelector('[data-open="drawer-shortlist"]');
    render();
    if (b) b.click();
  }

  if (body) {
    body.addEventListener('click', function (e) {
      var row = e.target.closest('.sr-sl-item'); if (!row) return;
      var i = +row.getAttribute('data-sl-i'), list = view === 'shared' && shared ? shared : load(), it = list[i];
      if (!it) return;
      if (e.target.closest('[data-sl-remove]')) {
        var mine = load(); mine.splice(i, 1); save(mine); render(); return;
      }
      if (e.target.closest('[data-sl-edit]') && it.d) { try { localStorage.setItem('sr-door', JSON.stringify(it.d)); } catch (err) {} }
      var add = e.target.closest('[data-sl-add]');
      if (add && !add.disabled) {
        add.disabled = true; add.textContent = 'Adding…';
        fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: +add.getAttribute('data-sl-variant'), quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); }); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { productId: '' } }));
            add.textContent = 'Added'; msg('Added to your cart.');
            track('shortlist_add_to_cart', { design: it.m + '_' + it.z + '_' + it.b });
            markCart(it);
            setTimeout(function () { add.textContent = 'Add to cart'; add.disabled = false; }, 2500);
          })
          .catch(function (ex) { add.textContent = 'Add to cart'; add.disabled = false; msg(ex.message); });
      }
    });
    body.addEventListener('input', function (e) {
      var ta = e.target.closest('[data-sl-note]'); if (!ta || view === 'shared') return;
      var i = +ta.closest('.sr-sl-item').getAttribute('data-sl-i');
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { var mine = load(); if (mine[i]) { mine[i].n = ta.value.slice(0, NOTE_MAX); save(mine); } }, 300);
    });
  }
  if (body) {
    body.addEventListener('click', function (e) {
      if (e.target.closest('[data-sl-share]')) {
        var list = load(), url = shareLink(list, 'share');
        var text = SUBJECT + ' (' + list.length + (list.length === 1 ? ' design)' : ' designs)');
        track('shortlist_share', { items: list.length });
        if (navigator.share) { navigator.share({ title: SUBJECT, text: text, url: url }).catch(function () {}); return; }
        var done = function () { msg('Link copied. Paste it into a message or email.'); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link to share your shortlist', url); });
        else window.prompt('Copy this link to share your shortlist', url);
      }
      // Email: point the link at a ready-made email just before the browser follows it
      var mail = e.target.closest('[data-sl-email]');
      if (mail) { mail.href = emailHref(load()); track('shortlist_email', { items: load().length }); }
      if (e.target.closest('[data-sl-save]') && shared) {
        var mine = load(), have = {};
        mine.forEach(function (it) { have[key(it)] = it; });
        shared.forEach(function (it) {
          var own = have[key(it)];
          if (own) { if (!own.n && it.n) own.n = it.n; }
          else { var c = clean(it); c.t = Date.now(); mine.push(c); }
        });
        if (mine.length > MAX) mine.length = MAX;
        save(mine); track('shortlist_saved_shared', { items: shared.length });
        shared = null; view = 'mine'; render(); msg('Saved to your shortlist.');
      }
      if (e.target.closest('[data-sl-mine]')) { view = 'mine'; render(); }
    });
  }
  // The header heart opens the drawer (theme code); draw the current list first
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-open="drawer-shortlist"]')) return;
    if (view !== 'shared') view = 'mine';
    render();
    if (e.isTrusted) track('shortlist_open', { items: load().length });
  }, true);
  // Another tab changed the list
  window.addEventListener('storage', function (e) { if (e.key === KEY) { emit(load()); } });

  // ---- Product pages (snippets/block--product-buy-buttons.liquid, 19 Oct): the heart beside Add to cart saves the chosen
  // size and button finish, plus the door picked in the Door Visualiser (window.SRDoorPick, assets/sr-door-pdp.js).
  // It waits, like Add to cart, until both a size and a finish are chosen.
  function pdpDesign(btn) {
    var z = '', b = '', f = btn.getAttribute('data-form');
    document.querySelectorAll('input[form="' + f + '"]:checked').forEach(function (i) {
      if (i.name === 'Size') z = sizeId(i.value); else if (i.name === 'Detail Finish') b = slug(i.value);
    });
    return z && b ? { m: btn.getAttribute('data-sr-heart'), z: z, b: b } : null;
  }
  function pdpState() {
    var mine = load();
    document.querySelectorAll('[data-sr-heart]').forEach(function (btn) {
      var d = pdpDesign(btn), on = !!d && mine.some(function (it) { return key(it) === key(d); });
      btn.disabled = !d;
      if (d) btn.removeAttribute('title'); else btn.title = 'Choose a size and finish first';
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on ? 'Remove from shortlist' : 'Save to shortlist');
    });
  }
  var pdpTimer;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sr-heart]');
    if (btn && !btn.disabled) {
      var d = pdpDesign(btn), pick = window.SRDoorPick;
      if (!d) return;
      if (pick) { d.d = pick.id; d.dn = pick.name; }
      var on = window.SRShortlist.toggle(d);
      pdpState();
      track(on ? 'shortlist_add' : 'shortlist_remove', { design: d.m + '_' + d.z + '_' + d.b, page: 'product' });
      var box = btn.parentNode.querySelector('[data-sr-saved]');
      if (box) {
        box.querySelector('[data-sr-saved-text]').textContent = on ? 'Saved to your shortlist' : 'Removed from your shortlist';
        box.hidden = false;
        clearTimeout(pdpTimer); pdpTimer = setTimeout(function () { box.hidden = true; }, 4000);
      }
      return;
    }
    var vb = e.target.closest('[data-sr-saved-view]');
    if (vb) { var bx = vb.closest('[data-sr-saved]'); if (bx) bx.hidden = true; window.SRShortlist.open(); }
  });
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) pdpState(); });
  document.addEventListener('sr-shortlist:change', pdpState);

  window.SRShortlist = {
    list: load,
    has: function (m, z, b) { return load().some(function (it) { return it.m === m && it.z === z && it.b === b; }); },
    toggle: function (it) {
      var c = clean(it); if (!c) return false;
      var list = load(), i = -1;
      list.forEach(function (x, j) { if (key(x) === key(c)) i = j; });
      if (i >= 0) { list.splice(i, 1); save(list); return false; }
      list.unshift(c); if (list.length > MAX) list.length = MAX; save(list); return true;
    },
    open: function () { view = 'mine'; openDrawer(); }
  };
  emit(load());
  pdpState();

  // A shared link: show it once the page (and the drawer styles) have loaded, then tidy the address bar
  var qs = new URLSearchParams(location.search);
  if (qs.get('shortlist')) {
    try { shared = decode(qs.get('shortlist')); } catch (e) { shared = null; }
    qs.delete('shortlist');
    try { history.replaceState(null, '', location.pathname + (qs.toString() ? '?' + qs.toString() : '') + location.hash); } catch (e) {}
    if (shared && shared.length) {
      view = 'shared';
      var show = function () { setTimeout(function () { openDrawer(); track('shortlist_shared_open', { items: shared ? shared.length : 0 }); }, 300); };
      if (document.readyState === 'complete') show(); else window.addEventListener('load', show);
    }
  }
})();
